/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';
import ChargeCard from './ChargeCard';

const RechargeWallet = ({ userData }) => {
  const [bundelsArray, setBundelsArray] = useState([]);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const getBundelsData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/api/v1/bundles/bundles-list/`
      );
      console.log("Bundles API raw response:", response.data);
      setBundelsArray(response.data.results);
    } catch (err) {
      console.error("Error fetching bundles:", err);
    }
  };

  useEffect(() => {
    getBundelsData();
  }, []);


  return (
    <>
      {/* العنوان الرئيسي */}
      <Stack width="100%" alignItems="center" sx={{ py: 2 }}>
        <Typography
          variant="h5"
          sx={{ padding: '0.5rem', borderBottom: 2, borderColor: 'gray' }}
        >
          Choose your suitable card and recharge your wallet now
        </Typography>
      </Stack>

      {/* شبكة البطاقات */}
      <Grid container spacing={3} justifyContent="center">
        {bundelsArray.map((bundle) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={bundle.id}>
            <ChargeCard bundle={bundle} userData={userData} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default RechargeWallet;
